angular.module('storefrontApp')
    .controller('cartBarController', [
        '$scope',
        '$window',
        'cartService',
        '$document',
        function (
            $scope,
            $window,
            cartService,
            $document,
        ) {
            getCart();

            $scope.$on('cartItemsChanged', () => {
                getCart();
            });

            $scope.isMobilePopupVisible = false;
            $scope.toggleMobilePopup = function () {
                $scope.isMobilePopupVisible = !$scope.isMobilePopupVisible;
                if ($scope.isMobilePopupVisible) {
                    $window.closeMobileMenu();
                }
            };

            $document.on('click', (e) => {
                if (!angular.element(e.target)
                    .closest('#mobileCartPopup').length && $scope.isMobilePopupVisible) {
                    $scope.$apply($scope.toggleMobilePopup());
                }
            });

            function getCart() {
                $scope.isLoading = true;
                cartService.getCart()
                    .then((response) => {
                        $scope.cart = response.data;
                        $scope.cartItemsCount = response.data.items.length;
                        $scope.isLoading = false;
                    });
            }
        }])

    .controller('recentlyAddedCartItemDialogController', [
        '$scope',
        '$window',
        '$uibModalInstance',
        'dialogData',
        function (
            $scope,
            $window,
            $uibModalInstance,
            dialogData,
        ) {
            $scope.$on('cartItemsChanged', () => {
                dialogData.updated = true;
            });

            $scope.dialogData = dialogData;

            $scope.close = function () {
                $uibModalInstance.close();
            };

            $scope.redirect = function (url) {
                $window.location = url;
            };
        }]);
